import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import CompanySnapshotTool from '@containers/DigitalAnalyst/CompanySnapshotTool';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function CompanySnapshot() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <CompanySnapshotTool onGoBack={onGoBack} />
      </Body>
    </PageWrapper>
  );
}

export default CompanySnapshot;
